export default __webpack_public_path__ + "5d024554b7f0ccbde93285d3fcbfd34e.svg";